import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }

    const sessionId = match[1];
    // Clear the hash immediately
    window.history.replaceState(null, "", window.location.pathname);

    const exchangeSession = async () => {
      try {
        const res = await axios.post(`${API}/auth/google/session`, { session_id: sessionId }, { withCredentials: true });
        const { user, needs_role } = res.data;

        // Store user in localStorage for AuthContext to pick up
        localStorage.setItem("google_user", JSON.stringify(user));

        if (needs_role) {
          navigate("/select-role", { replace: true, state: { user } });
        } else {
          const dashboards = { customer: "/customer", business: "/business", admin: "/admin" };
          navigate(dashboards[user.user_type] || "/", { replace: true });
        }
      } catch {
        navigate("/login", { replace: true });
      }
    };

    exchangeSession();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <div className="text-center">
        <div className="w-8 h-8 border-4 border-[#0B1F3B] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600">Signing you in...</p>
      </div>
    </div>
  );
}
